import { DataVolume, Entity, FieldType, PersistenceType } from 'gossamer-unified';

export interface TransactionRow {
  trans_id: string;
  user_id: string;
  role_id: string;
  status: string;
  front_end_save_at: string;
  back_end_save_at: string;
  front_end_path: string;
  back_end_path: string;
  outcome_id: string;
  reason: string;
  info: string;
  warn: string;
  error: string;
}

export const Transaction: Entity<TransactionRow> = {
  id: 'Transaction',
  title: 'Transaction',
  service: 'main',
  rowLabel: (row: TransactionRow) => new Date(row.back_end_save_at).toLocaleString(),
  primaryKeyFields: ['trans_id'],
  source: {
    tableName: 'public.transaction',
  },
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: "user_id = '{userId}'" },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  defaultSort: [['back_end_save_at', 'DESC']],
  defaultFilters: [{ fieldId: 'trans_id', operator: 'ct', value: '' }],
  listRowLink: '/admin/transaction/display/{key}',
  dataVolume: DataVolume.Large,
  fields: {
    trans_id: {
      seq: 5,
      type: FieldType.Text,
      label: 'Transaction Id',
      persistence: PersistenceType.BackEndManaged,
      maxLength: 50,
    },
    user_id: {
      seq: 10,
      type: FieldType.Text,
      label: 'User',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    role_id: {
      seq: 15,
      type: FieldType.Text,
      label: 'Role Id',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      maxLength: 50,
    },
    status: {
      seq: 17,
      type: FieldType.Options,
      label: 'Status',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      options: [
        { id: 'started', label: 'started' },
        { id: 'success', label: 'success' },
        { id: 'fail', label: 'fail' },
      ],
    },
    front_end_save_at: {
      seq: 20,
      type: FieldType.Datetime,
      label: 'Front End Save At',
      persistence: PersistenceType.BackEndManaged,
    },
    back_end_save_at: {
      seq: 25,
      type: FieldType.Datetime,
      label: 'Back End Save At',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    front_end_path: {
      seq: 35,
      type: FieldType.Text,
      label: 'Front End Path',
      persistence: PersistenceType.BackEndManaged,
      maxLength: 250,
    },
    back_end_path: {
      seq: 37,
      type: FieldType.Text,
      label: 'Back End Path',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      maxLength: 250,
    },
    outcome_id: {
      seq: 40,
      type: FieldType.Text,
      label: 'Outcome',
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
      maxLength: 50,
    },
    reason: {
      seq: 45,
      type: FieldType.Richtext,
      label: 'Reason',
      persistence: PersistenceType.SetOnCreateOnly,
    },
    info: {
      seq: 50,
      type: FieldType.Richtext,
      label: 'Info',
      persistence: PersistenceType.BackEndManaged,
    },
    warn: {
      seq: 55,
      type: FieldType.Richtext,
      label: 'Warnings',
      persistence: PersistenceType.BackEndManaged,
    },
    error: {
      seq: 60,
      type: FieldType.Richtext,
      label: 'Errors',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
